async function somePromiseFn(): Promise<string> {
  let value = 'promise-value';
  return value; 
}

somePromiseFn().then(d => console.info(d));